module.exports = __webpack_public_path__ + "img/M007-08_jrb-01.927322e8.jpg";